import React from 'react'
import PropTypes from 'prop-types'
import * as _ from 'lodash'
import styled from 'styled-components'

// eslint-disable-next-line no-unused-vars
const FilteredLineDivider = ({hasChildren, ...otherProps}) => <div {...otherProps} />
FilteredLineDivider.propTypes = {
  hasChildren: PropTypes.bool
}
const StyledLineDivider = styled(FilteredLineDivider)`
  display: flex;
  align-items: center;
  text-align: center;
  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  ${(props) =>
    props.hasChildren &&
    `
    &::before {
      margin-right: .25em;
    }
    &::after {
      margin-left: .25em;
    }
  `}
`

export const LineDivider = (props) => (
  <StyledLineDivider {..._.omit(props, 'children')} hasChildren={!!props.children}>
    {props.children}
  </StyledLineDivider>
)

LineDivider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}
